import { render } from "./allegatiInterniModal.vue?vue&type=template&id=80b52574&scoped=true&ts=true"
import script from "./allegatiInterniModal.vue?vue&type=script&lang=ts"
export * from "./allegatiInterniModal.vue?vue&type=script&lang=ts"

import "./allegatiInterniModal.vue?vue&type=style&index=0&id=80b52574&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b52574"]])

export default __exports__